import { flatten } from 'lodash';

function generateWaves(values: DistanceType[]): WaveType[] {
  const waves = values.map((distance) => distance.waves || []);
  return flatten(waves);
}

export { generateWaves };
